interface TocItem {
  id: string;
  text: string;
}

interface ArticleTocProps {
  items: TocItem[];
  activeId: string;
}

export default function ArticleToc({ items, activeId }: ArticleTocProps) {
  if (items.length === 0) return null;

  return (
    <nav
      aria-label="文章目录"
      className="rounded-lg border border-background-200 bg-background-100 p-5"
    >
      <h2 className="font-heading text-sm font-bold text-foreground-950 mb-3 inline-flex items-center gap-1.5">
        <i className="ri-list-check-2 w-4 h-4 flex items-center justify-center text-accent-600" />
        本文目录
      </h2>
      <ul className="space-y-1.5 border-l-2 border-background-200">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`block pl-3 py-1 text-sm leading-snug transition-colors cursor-pointer border-l-2 -ml-0.5 ${
                activeId === item.id
                  ? "border-accent-500 text-accent-700 font-bold"
                  : "border-transparent text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}